/* FOLLOWER BOOST — generic "show N first, reveal the rest" toggle (mobile compaction).
   Markup: [data-fb-more-grid][data-mobile-visible=N] + button[data-fb-more-toggle][aria-controls]
   All items stay in the DOM (SEO / a11y); only their visibility changes under 750px. */
(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-fb-more-toggle]:not([data-fb-ready])').forEach((btn) => {
      btn.dataset.fbReady = '1';
      const grid = document.getElementById(btn.getAttribute('aria-controls'));
      if (!grid) return;
      const label = btn.querySelector('[data-fb-more-label]') || btn;
      btn.addEventListener('click', () => {
        const open = grid.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.classList.toggle('is-open', open);
        label.textContent = open ? btn.dataset.less : btn.dataset.more;
        if (open) {
          grid.querySelectorAll('.fb-reveal').forEach((el) => el.classList.add('is-in'));
        } else {
          // keep the user's place: bring the grid top back into view when collapsing
          const top = grid.getBoundingClientRect().top;
          if (top < 0) grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (e) => setup(e.target));
})();
